module.exports = __webpack_public_path__ + "static/media/thesmartglove.d3960a6a.png";